export default __webpack_public_path__ + "static/media/hero-apps.688cf2f6.jpg";